// Company API
import {
    RequestConfigFunction,
    SelectorConfig,
} from 'app/types/request.types'

type CompanyRequests = {
    get: RequestConfigFunction<{id: number}>,
    skyMindSyncUpdate: RequestConfigFunction<{id: number}>,
    archive: RequestConfigFunction<{id: number}>,
    restore: RequestConfigFunction<{id: number}>,
    trackingData: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<{data: any}>,
    create: RequestConfigFunction<{data: any}>,
    duplication: RequestConfigFunction<{data: Record<string, any>}>,
    selector: SelectorConfig<{ companyName: string, id: string }[]>,
    requestParentsSubsidiaries: RequestConfigFunction<{id: number}>,
    getAll?: RequestConfigFunction<Record<string, any>>,
}

const companyRequests: CompanyRequests = {
    get: ({
        id,
    }) => {
        return {
            url: `company/${id}`,
            method: 'GET',
        }
    },
    skyMindSyncUpdate: ({
        id,
    }) => {
        return {
            url: `company/${id}/skymind-sync`,
            method: 'PATCH',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `company/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `company/${id}/restore`,
            method: 'PATCH',
        }
    },
    trackingData: ({
        id,
    }) => {
        return {
            url: `company/${id}/tracking-data`,
            method: 'PATCH',
        }
    },
    update: ({
        data,
    }) => {
        return {
            url: 'company',
            method: 'PUT',
            data,
        }
    },
    create: ({
        data,
    }) => {
        return {
            url: 'company',
            method: 'POST',
            data,
        }
    },
    duplication: ({
        data,
    }) => {
        return {
            url: 'company/duplicate-check',
            method: 'POST',
            data,
        }
    },
    selector: {
        url: 'company/filter-request/selector',
        convertion: (companies) => {
            return companies.map(({
                companyName, id,
            }) => {
                return {
                    value: id,
                    label: companyName,
                    id,
                }
            })
        },
    },
    getAll: (data = {}) => {
        return {
            url: 'company/filter-request/selector',
            method: 'POST',
            data,
        }
    },
    requestParentsSubsidiaries: ({
        id,
    }) => {
        return {
            url: 'company/filter-request/all',
            method: 'POST',
            includeFilters: {
                parentCompanyId: [id],
            },
        }
    },
}

export default companyRequests
